import { Controller } from "stimulus"

// Connects to data-controller="ridp-rba-consent"
export default class extends Controller {
  static targets = ["agreeRadio", "disagreeRadio", "continueButton", "disagreeDisclaimer", "consentForm", "jscToken", "hdimToken"]

  connect() {
    this.updateButtonState()
    this.setupTokenMonitoring()
  }

  handleAgree() {
    // Enable the submit button for form submission
    this.continueButtonTarget.disabled = false
    this.continueButtonTarget.classList.remove('disabled')
    this.continueButtonTarget.type = 'submit'
    this.continueButtonTarget.onclick = null
    this.disagreeDisclaimerTarget.classList.add('hide')
    this.consentFormTarget.action = "wait"
    this.consentFormTarget.method = "post"
  }

  handleDisagree() {
    // Enable the button and show disclaimer
    this.continueButtonTarget.disabled = false
    this.continueButtonTarget.classList.remove('disabled')
    this.continueButtonTarget.type = 'button'
    this.continueButtonTarget.onclick = (e) => {
      e.preventDefault()
      e.stopImmediatePropagation()
      window.location.href = this.continueButtonTarget.dataset.manualUploadUrl
    }
    this.disagreeDisclaimerTarget.classList.remove('hide')
    this.consentFormTarget.action = "wait"
    this.consentFormTarget.method = "post"
  }

  updateButtonState() {
    // Initialize button state based on default checked radio
    if (this.agreeRadioTarget.checked) {
      this.handleAgree()
    } else if (this.disagreeRadioTarget.checked) {
      this.handleDisagree()
    }
  }

  // Monitor token collection status
  setupTokenMonitoring() {
    // Check if tokens are collected every 500ms
    this.tokenCheckInterval = setInterval(() => {
      const jscToken = this.hasJscTokenTarget ? this.jscTokenTarget.value : ''
      const hdimToken = this.hasHdimTokenTarget ? this.hdimTokenTarget.value : ''
      
      if (jscToken && hdimToken) {
        this.onTokensCollected()
      }
    }, 500)
  }

  onTokensCollected() {
    // Clear the interval once tokens are collected
    if (this.tokenCheckInterval) {
      clearInterval(this.tokenCheckInterval)
    }
  }

  disconnect() {
    // Clean up interval when controller disconnects
    if (this.tokenCheckInterval) {
      clearInterval(this.tokenCheckInterval)
    }
  }
}
